// @flow

import React, { type ElementProps } from "react";
import { ObjectFieldTemplateProps } from "react-jsonschema-form";

type Props = ElementProps<typeof ObjectFieldTemplateProps>;

const ObjectFieldTemplate = (props: Props) => {
  if (props.uiSchema["ui:widget"] === "hidden") {
    return null;
  }

  let currentCol = 1;
  let columns = { col1: [], col2: [], col3: [] };
  props.properties.forEach(element => {
    if (currentCol > 3) currentCol = 1;
    columns[`col${currentCol}`].push(element.content);
    ++currentCol;
  });

  // If there are at least two elements will produce 3 columns, otherwise will render - directly
  // This is for dropdowns like "Absence reason" which for some reason are using this field template
  return props.properties.length < 2 ? (
    columns.col1[0]
  ) : (
    <React.Fragment>
      <div className={"d-flex flex-column"}>
        {columns.col1.map((el, idx: number) => (
          <div key={idx} className="element-wrapper">
            {el}
          </div>
        ))}
      </div>
      <div className={"d-flex flex-column"}>
        {columns.col2.map((el, idx: number) => (
          <div key={idx} className="element-wrapper">
            {el}
          </div>
        ))}
      </div>
      <div className={"d-flex flex-column"}>
        {columns.col3.map((el, idx: number) => (
          <div key={idx} className="element-wrapper">
            {el}
          </div>
        ))}
      </div>
    </React.Fragment>
  );
};

export default ObjectFieldTemplate;
